//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - Start 
import { Col, Container, Row } from "react-bootstrap";
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader } from "../../components";
import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleModal } from "../../redux/actions/modals";
import { exitCoverOrder } from "../../apis";
import { getAllOrders } from "../../redux/actions/orders";
import { ORDERBOOK_API_ORDER_STATUS, ORDERS_LIMIT_IN_API, ORDERS_TABKEY } from "../../utils/global_variables";


const ExitOrderModal = ({ ordersTabKey, ...props }) => {
    const dispatch = useDispatch();
    const objExitOrderData = useSelector(state => state.orders?.objExitOrderData);

    const handleClose = () => {
        dispatch(handleModal([{ "EXIT_ORDER_MODAL": false }]));
        dispatch(updateExitOrderData({}));
    };
    const modals = useSelector(state => state.modals?.modals);

    const handleExitOrder = async () => {
        let coverExitprice = 0;
        let buyPrice = 0;
        let sellPrice = 0;
        let MPClosePrice = 0;

        MPClosePrice = !objExitOrderData?.closePrice ? 0 : parseFloat(objExitOrderData?.closePrice);
        buyPrice = (!objExitOrderData?.buyPrice || objExitOrderData?.buyPrice == "-") ? 0 : parseFloat(objExitOrderData?.buyPrice);
        sellPrice = (!objExitOrderData?.sellPrice || objExitOrderData?.sellPrice == "-") ? 0 : parseFloat(objExitOrderData?.sellPrice);
        let ltp = (objExitOrderData?.ltp) ? parseFloat(objExitOrderData?.ltp) : 0;
        if (objExitOrderData?.type == 'BUY') {
            coverExitprice = ltp || buyPrice || sellPrice;
            if (ltp && buyPrice) {
                coverExitprice = Math.min(ltp, buyPrice);
            }
            if (coverExitprice && sellPrice) {
                coverExitprice = Math.min(coverExitprice, sellPrice);
            }
        }
        else {
            let dblPrice1 = Math.max(sellPrice, ((objExitOrderData.ltp) ? parseFloat(objExitOrderData.ltp) : 0));
            let dblPrice2 = Math.max(dblPrice1, buyPrice);
            coverExitprice = dblPrice2;
        }
        if (parseInt(coverExitprice) == 0) {
            coverExitprice = MPClosePrice;
        }
        const objResp = await exitCoverOrder(objExitOrderData?.exchangeSegment, objExitOrderData?.orderNo, coverExitprice);
        if (objResp?.data?.status === 'success') {
            setTimeout(() => {
                if (ordersTabKey === ORDERS_TABKEY.ALL_ORDERS) {
                    dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.ALL_ORDERS }));
                } else if (ordersTabKey === ORDERS_TABKEY.OPEN_ORDERS) {
                    dispatch(getAllOrders({ offSet: 1, limit: ORDERS_LIMIT_IN_API, orderStatus: ORDERBOOK_API_ORDER_STATUS.OPEN_ORDERS }));
                }
            }, 3000);
            dispatch(handleModal([{ "EXIT_ORDER_MODAL": false }]));
        }
    };

    return (
        <BzModal className='modal-breeze' show={modals['EXIT_ORDER_MODAL']} onHide={handleClose} centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-items-center'>
                            <div className='font-medium font-size4 color-text'>Exit Order</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-items-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody>
                <Container fluid className='p-0'>
                    <Row className='g-0 pb-2 mb-2'>
                        <Col>
                            <div className='font-regular font-size4 color-text'>Are you sure you want to exit the order? Any pending order will be cancelled </div>
                        </Col>
                    </Row>
                </Container>
            </BzModalBody>
            <BzModalFooter>
                <Container fluid className='p-0 m-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-end'>
                            <BzButton className='btn btn-md btn-outline text-uppercase me-2' onClick={handleClose}>CLOSE</BzButton>
                            <BzButton className='btn btn-md btn-primary text-uppercase ms-2' onClick={handleExitOrder}>EXIT ORDER</BzButton>
                        </Col>
                    </Row>
                </Container>
            </BzModalFooter>
        </BzModal>
        // <OrderStatus />  
    );
};
export default memo(ExitOrderModal);
//  Azeem K : 15-04-2025 : BREEZE-6542 -Breeze - Margin Plus Order - End
